import React from 'react'
import { hexToRGBA } from 'src/@core/utils/hex-to-rgba'
import { FeatureStatus } from 'src/lib/types/support'

interface RequestListBadge {
  type: FeatureStatus
  count: number
  isViewMode?: boolean
}

const RequestListBadge: React.FC<RequestListBadge> = ({ type, count, isViewMode = false }) => {
  const renderBage = () => {
    switch (type) {
      case 'todo':
        return <FeatureBadge color={'#6E6E6E'} count={count} headerText={'To do'} isViewMode={isViewMode} />
      case 'progress':
        return <FeatureBadge color='#407BA5' count={count} headerText='In progress' isViewMode={isViewMode} />
      case 'review':
        return <FeatureBadge color='#C7981F' count={count} headerText='In review' isViewMode={isViewMode} />
      case 'deferred':
        return <FeatureBadge color='#B25552' count={count} headerText='For later' isViewMode={isViewMode} />
      case 'completed':
        return <FeatureBadge color='#2C874A' count={count} headerText='Completed' isViewMode={isViewMode} />
    }
  }
  return <div>{renderBage()}</div>
}

const FeatureBadge = ({
  color,
  count,
  headerText,
  isViewMode
}: {
  color: string
  count: number
  headerText: string
  isViewMode: boolean
}) => {
  const borderColor = hexToRGBA(color, 0.25)
  const backgroundColor = hexToRGBA(color, 0.1)

  return (
    <div className='flex justify-between w-full rounded-xl border-1 ' style={{ backgroundColor, borderColor, color }}>
      <div className='rounded-xl flex gap-3  py-2 px-6 items-center'>
        <h3 className='text-base font-semibold'>{headerText}</h3>
        {!isViewMode && <p className='bg-white px-2 py-0.5 rounded-full'>{count}</p>}
      </div>
    </div>
  )
}

export default RequestListBadge
